import {
  fromConstant,
  fromUrl,
  resolveProvidedPrimitive,
} from "@bloglovin/inspire-engine/Helpers/PrimitiveContextValue";
import ProvidesContextEntry from "%/dynamic-component-editor/classes/provides-context-entry";
import { assertNotExpressionGlobalName } from "%/dynamic-component-editor/helpers/expression-globals";

const TYPE_STRING = "string";

function typedInput(owner, contextName, type, raw) {
  if (type === TYPE_STRING || typeof raw !== "string") {
    return raw;
  }
  try {
    return fromUrl(owner, contextName, { type, uriVar: contextName }, encodeURIComponent(raw));
  } catch {
    return raw;
  }
}

export function buildPrimitiveProvidesEntry({
  owner, contextName, type, entitySource, value, uriVar, uriVars = [], allowUri = false,
}) {
  assertNotExpressionGlobalName(contextName, owner);
  if (entitySource === ProvidesContextEntry.KEY_URI) {
    const entry = ProvidesContextEntry.build({ type, entitySource, uriVar });
    const presentVars = Object.fromEntries((uriVars ?? []).map(name => [name, "true"]));
    if (!allowUri || !Object.prototype.hasOwnProperty.call(presentVars, uriVar)) {
      resolveProvidedPrimitive({ owner, contextName, def: entry, urlVars: {}, allowUri });
    }
    return entry;
  }
  const entry = ProvidesContextEntry.build({
    type,
    entitySource,
    value: typedInput(owner, contextName, type, value),
  });
  fromConstant(owner, contextName, entry);
  return entry;
}

export function primitiveProvidesEntryError(args) {
  try {
    buildPrimitiveProvidesEntry(args);
    return "";
  } catch (error) {
    return error.message;
  }
}

export function builderPrimitiveValues(providesContexts, owner) {
  const values = {};
  Object.entries(providesContexts ?? {}).forEach(([contextName, entry]) => {
    if (!ProvidesContextEntry.isPrimitive(entry)) {
      return;
    }
    if (entry.entitySource === ProvidesContextEntry.KEY_URI) {
      if (entry.type === TYPE_STRING) {
        values[contextName] = `{${entry.uriVar}}`;
      }
      return;
    }
    try {
      values[contextName] = fromConstant(owner, contextName, entry);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`${error.message} — the builder cannot show it, and staging will refuse to render.`);
    }
  });
  return values;
}
